import { Grid } from '@mui/material';
import { RoutalDialog, VSpacer } from '@nx-smartmonkey/ui';

import CommunicationEnableSMS from '../../../../assets/img/communication-enable-sms.png';
import { intl } from '../../../../helpers/IntGlobalProvider';
import Button from '../../../../react-components/Button';
import Text from '../../../../react-components/Text';
import eventsPanel from '../../../../services/events';
import { intercom } from '../../../../services/intercom';

interface NotificationsSMSEnableDialogProps {
  open: boolean;
  onClose: (...args: any[]) => any;
}

export const NotificationsSMSEnableDialog = ({ onClose, open }: NotificationsSMSEnableDialogProps) => (
  <RoutalDialog
    open={open}
    dialogProps={{
      fullWidth: true,
      maxWidth: `sm`,
    }}
    onCloseDialog={onClose}
    titleContent={<Text variant="h6" intlId="projects.communication.messages.sms.need_administrator.title" />}
    footerContent={
      <Button
        styleType="primary"
        onClick={() => {
          eventsPanel.projectCommunication({ action: `enable_sms_request` });
          intercom.message(
            intl.formatMessage({ id: `projects.communication.messages.sms.need_administrator.request` })
          );
          onClose();
        }}
        intlId="projects.communication.messages.sms.need_administrator.request_button"
      />
    }
  >
    <Grid container direction="column">
      <Text intlId="projects.communication.messages.sms.need_administrator.description" />
      <VSpacer medium />
      <img src={CommunicationEnableSMS} alt="" draggable="false" />
      <VSpacer small />
    </Grid>
  </RoutalDialog>
);
